import { adjustDateRange } from '@frontend/common';
import React, { useMemo } from 'react';

import { FromToDateOnlyProps } from './from-to-date-only.component';

export const useFromToDateOnly = (props: FromToDateOnlyProps) => {
    const fromDate = useMemo(() => props.fromDate, [props.fromDate]);
    const toDate = useMemo(() => props.toDate, [props.toDate]);

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>, dateType: 'from' | 'to') => {
        const newDateStr = e.target.value;

        if (!fromDate && !toDate) {
            if (dateType === 'from') {
                props.onFromDateChange(new Date(newDateStr).toISOString());
            } else {
                props.onToDateChange(new Date(newDateStr).toISOString());
            }
            return;
        }

        const adjusted = adjustDateRange(fromDate, toDate, newDateStr, dateType);
        props.onFromDateChange(adjusted.fromDate.toISOString());
        props.onToDateChange(adjusted.toDate.toISOString());
    };

    return { fromDate, toDate, handleDateChange };
};
